import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=7f548169"
import script from "./NotificationsList.vue?vue&type=script&lang=js"
export * from "./NotificationsList.vue?vue&type=script&lang=js"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=7f548169&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports